<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e134">
<div class="tx11">
<p class="h3" id="d41151341"><b>HOW TO</b></p>
<p class="h3" id="d41151342"><b>ROB AN</b></p>
<p class="h3" id="d41151343"><b>ARMORED</b></p>
<p class="h3" id="d41151344"><b>CAR </b></p>
</div>
<div class="tx12">
<p class="h4" id="d41151381"><b>iain</b></p>
<p class="h4" id="d41151382"><b>Levison </b></p>
</div>
<p style="text-align:center;"><img alt="1114115140" id="d11141151401" src="images/9781569475997_0004_001.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap3_howtorob_9781569477113_epub_part3.vue?76f7e18c